<template>
    <div>
        <el-dialog
            :visible.sync="visible"
            :title="dialogTitle"
            :close-on-click-modal="false"
            class="attend_dialog"
            width="736px"
            :before-close="()=>$emit('update:visible', false)"
        >
            <el-table
                :data="attendanceList"
                style="width: 100%;"
                height="100%">
                <template slot="empty">
                    <cl-no-data img-type="personnel" text="暂无数据"></cl-no-data>
                </template>
                <el-table-column :label="$t('schedule.考勤')" prop="state" width="100">
                    <template slot-scope="scope">
                        <div class="icon">
                            <img :src="scope.row.state ? require('@assets/images/common/clockIn-yes.svg') : require('@assets/images/schedule/absent.svg') "
                                class="clock_state"/>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('team.姓名')" width="200">
                    <template slot-scope="scope">
                        <div class="avatar">
                            <cl-avatar
                                :src="scope.row.userAvatar"
                                width="40"
                                height="40"
                                radius="8px"
                                style="display: inline-block"
                            ></cl-avatar>
                            <span class="name ml12">{{scope.row.userName}}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('team.职位')" prop="title"></el-table-column>
                <el-table-column :label="$t('videoReport.视频')" width="70">
                    <template slot-scope="scope">
                        <span  v-if="scope.row.state" class="video" @click="videoFn(scope.row)">
                            <cl-svg-icon width="16" height="16" icon-class="mr_video_clips"></cl-svg-icon>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('schedule.打卡时间')" width="130">
                    <template slot-scope="scope">
                        <span>{{ scope.row.createTime ? $utils.formatTime('HH:mm:ss',Number(scope.row.createTime)) : $nullText }}</span>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
        <!--视频播放弹窗-->
        <cl-preview-video-dialog 
            :visible.sync="attendanceVideo" 
            v-if="attendanceVideo" 
            :previewData="previewData"
            :videoUrl="attendanceVideoUrl"
        />
    </div>
</template>

<script>
/**
 * Filename: 考勤
 * Created Date: 2022/6/8
 * Creator: zhangchao
 * Copyright (c) 2022 Your Company
 */
export default {
    name: 'cl-attendance-staff',
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        random: {
            type: String,
            default: '',
        },
        attendanceList: {
            type: Array,
            default: ()=>[],
        },
    },
    data () {
        return {
            previewData: {},
            attendanceVideoUrl: '',
            attendanceVideo: false,
        }
    },
    computed: {
        dialogTitle() {
            return this.random ? this.$t('schedule.打卡内容') + ' - ' + this.random : this.$t('schedule.打卡内容')
        }
    },
    methods: {
        // 点击考勤内视频
        videoFn (item) {
            this.previewData = {
                name: item.userName,
                createTime: item.createTime
            };
            this.attendanceVideoUrl = item.file;
            this.attendanceVideo = true;
        },
    }
}
</script>

<style lang="scss" scoped>
.attend_dialog /deep/ {
    .el-dialog__body{
        height: 60vh;
    }

    .avatar {
        display: flex;
        line-height: 40px;
    }

    .video{
        cursor: pointer;
        color: #3663E1;
    }

    .el-table .el-table__body tr:hover > td.el-table__cell{
        .video{
            cursor: pointer;
            color: #ffffff;
        }
    }
}
</style>
